module.exports = __webpack_public_path__ + "static/img/150016.a11817b1.png";